import { combineReducers } from "@reduxjs/toolkit";
import authSlice  from "../reducers/auth";
import dashboardSlice from "../reducers/dashboard";
import chatSlice from "../reducers/chatbot";
import subscriptionSlice from "./subscription";
import businessIntelligenceReducer from "./businessIntelligence"
import businessSummaryReducer from "./businessSummary"
import businessInsightsReducer from "./businessInsights"
import localIntelligenceReducer from "./localIntelligence/index";

const rootReducer = combineReducers({
  auth: authSlice,
  dashboard: dashboardSlice,
  chat: chatSlice,
  subscription: subscriptionSlice,
  businessIntelligence: businessIntelligenceReducer,
  localIntelligence: localIntelligenceReducer,
  businessSummary: businessSummaryReducer,
  businessInsights: businessInsightsReducer
});

export default rootReducer;
